module.exports = __webpack_public_path__ + "static/media/1001394DO.cc28fd64.jpg";